var app = angular.module('leonardo');

var DocumentListFilter = function (
  $rootScope,
  $scope,
  $controller,
  PermissionService,
  FolderService,
  $stateParams,
  FolderFileService
) {
  $controller('FiltersBaseController', { $scope: $scope });
  let isFromMail = $stateParams['from-mail'] === 'true';
  if (!$scope.filterService.hasFilter('property_reports') && $scope.filterService.currentProperty && !FolderService.isDefaultPropertyChanged && !isFromMail) {
    $scope.filterService.setFilter('property_reports', $scope.filterService.currentProperty.id, true);
  }

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'search',
      name: 'Keyword Search',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Keyword Search',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    },
    {
      id: 'role',
      name: 'Role',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      options: $scope.authDataService.getRolesValid(),
      condition: PermissionService.isOwner(),
      conflicts: []
    },
    {
      id: 'document_type',
      name: 'Document Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'All Documents',
      condition: true,
      options: [
        { id: FolderFileService.TYPE_NORMAL, name: 'Normal Documents' },
        { id: FolderFileService.TYPE_REPORT, name: 'Report Documents' }
      ],
      conflicts: []
    },
    {
      id: 'document_status',
      name: 'Document Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'All Statuses',
      condition: true,
      options: [
        { id: 'noticed', name: 'On Notice' },
        { id: 'expired', name: 'Expired' },
        { id: 'missing', name: 'Missing' }
      ],
      conflicts: []
    }
  ];

  $scope.filterService.showFilters(['property_reports', 'search']);

  function handlePropertyReportsChange(key) {
    if (key === 'property_reports') {
      FolderService.isDefaultPropertyChanged = true;
    }
  }

  $scope.$on('filter-service:filter-changed', function ($event, key, value) {
    handlePropertyReportsChange(key);
  });

  $scope.$on('filter-service:filter-removed', function ($event, key) {
    handlePropertyReportsChange(key);
  });

  function tryApplyIframeDocumentStatus() {
    if (!$rootScope.isInIframe) {
      return;
    }
    var raw = null;
    var parsed = null;
    try {
      raw = window.sessionStorage.getItem('iframe_filter_data');
      if (raw) {
        window.sessionStorage.removeItem('iframe_filter_data');
      }
      parsed = JSON.parse(raw);
    } catch (e) {}
    if (parsed && parsed.document_status) {
      $scope.filterService.setFilter('document_status', parsed.document_status, true);
      $scope.filterService.showFilters(['property_reports', 'search', 'document_status']);
    }
  }

  tryApplyIframeDocumentStatus();
};

app.controller('DocumentListFilter', [
  '$rootScope',
  '$scope',
  '$controller',
  'PermissionService',
  'FolderService',
  '$stateParams',
  'FolderFileService',
  DocumentListFilter
]);
